import { render, staticRenderFns } from "./HotsiteConfigurationFields.vue?vue&type=template&id=955bf1f2"
import script from "./HotsiteConfigurationFields.vue?vue&type=script&lang=js"
export * from "./HotsiteConfigurationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports